/**
 * @generated SignedSource<<934cc5d2695968ed48b3b6078ab6c545>>
 * @relayHash 9105248129bb2f05bee49298ecfa2820
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5408a98b5c717cefdf26326d1df7b97015009d11ef1e09a7900ed8888261a004

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TownsquareUpdateStateFilter = "ACTIVE" | "AT_RISK" | "CANCELLED" | "DONE" | "NO_UPDATE" | "OFF_TRACK" | "ON_TRACK" | "PAUSED" | "PENDING" | "%future added value";
export type ReadingModeFullScreenQuery$variables = {
  containerId: string;
  createdAfter?: AGG$DateTime | null | undefined;
  createdBefore?: AGG$DateTime | null | undefined;
  isGoalUpdates: boolean;
  isProjectUpdates: boolean;
  isTagUpdates: boolean;
  isTeamUpdates: boolean;
  stateFilter?: TownsquareUpdateStateFilter | null | undefined;
  tagId: string;
  teamId: string;
};
export type ReadingModeFullScreenQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GoalReadingModeInternals_GoalPagination" | "ProjectReadingModeInternals_ProjectPagination" | "TagReadingModeInternals_TagPagination" | "TeamReadingModeInternals_TeamPagination">;
};
export type ReadingModeFullScreenQuery = {
  response: ReadingModeFullScreenQuery$data;
  variables: ReadingModeFullScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "createdAfter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "createdBefore"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isGoalUpdates"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isProjectUpdates"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTagUpdates"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTeamUpdates"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "stateFilter"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tagId"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamId"
},
v10 = {
  "kind": "Variable",
  "name": "containerId",
  "variableName": "containerId"
},
v11 = {
  "kind": "Variable",
  "name": "createdAfter",
  "variableName": "createdAfter"
},
v12 = {
  "kind": "Variable",
  "name": "createdBefore",
  "variableName": "createdBefore"
},
v13 = {
  "kind": "Literal",
  "name": "first",
  "value": 15
},
v14 = {
  "kind": "Variable",
  "name": "stateFilter",
  "variableName": "stateFilter"
},
v15 = [
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/)
],
v16 = [
  (v10/*: any*/),
  (v11/*: any*/),
  (v13/*: any*/),
  {
    "kind": "Variable",
    "name": "teamId",
    "variableName": "teamId"
  }
],
v17 = [
  (v10/*: any*/),
  (v11/*: any*/),
  (v13/*: any*/),
  {
    "kind": "Variable",
    "name": "tagId",
    "variableName": "tagId"
  }
],
v18 = [
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v14/*: any*/)
],
v19 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v20 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isTownsquareUpdate"
},
v21 = {
  "kind": "ScalarField",
  "name": "id"
},
v22 = {
  "kind": "ScalarField",
  "name": "ari"
},
v23 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v24 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v25 = {
  "kind": "ScalarField",
  "name": "summary"
},
v26 = {
  "kind": "ScalarField",
  "name": "name"
},
v27 = {
  "kind": "ScalarField",
  "name": "picture"
},
v28 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v29 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": [
    (v19/*: any*/),
    (v26/*: any*/),
    (v27/*: any*/),
    (v21/*: any*/),
    (v28/*: any*/)
  ]
},
v30 = {
  "kind": "ScalarField",
  "name": "label"
},
v31 = {
  "concreteType": "TownsquareTargetDateRange",
  "kind": "LinkedField",
  "name": "dateRange",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "start"
    },
    {
      "kind": "ScalarField",
      "name": "end"
    }
  ]
},
v32 = [
  (v30/*: any*/),
  (v31/*: any*/)
],
v33 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "newDueDate",
  "plural": false,
  "selections": (v32/*: any*/)
},
v34 = [
  {
    "alias": "projectValue",
    "kind": "ScalarField",
    "name": "value"
  }
],
v35 = {
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": [
    (v19/*: any*/),
    (v28/*: any*/),
    (v26/*: any*/),
    (v21/*: any*/)
  ]
},
v36 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v37 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v38 = {
  "kind": "ScalarField",
  "name": "url"
},
v39 = [
  (v21/*: any*/)
],
v40 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v19/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v21/*: any*/),
          (v26/*: any*/),
          (v28/*: any*/),
          (v27/*: any*/)
        ],
        "type": "AtlassianAccountUser"
      },
      {
        "kind": "InlineFragment",
        "selections": (v39/*: any*/),
        "type": "AppUser"
      },
      {
        "kind": "InlineFragment",
        "selections": (v39/*: any*/),
        "type": "CustomerUser"
      }
    ]
  },
  (v21/*: any*/)
],
v41 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "oldDueDate",
  "plural": false,
  "selections": (v32/*: any*/)
},
v42 = {
  "kind": "ScalarField",
  "name": "newTargetDate"
},
v43 = {
  "kind": "ScalarField",
  "name": "newTargetDateConfidence"
},
v44 = {
  "kind": "ScalarField",
  "name": "description"
},
v45 = {
  "kind": "ScalarField",
  "name": "archived"
},
v46 = {
  "concreteType": "TownsquareUpdateNoteConnection",
  "kind": "LinkedField",
  "name": "updateNotes",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareUpdateNoteEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareUpdateNote",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v21/*: any*/),
            (v25/*: any*/),
            (v44/*: any*/),
            (v45/*: any*/)
          ]
        }
      ]
    }
  ]
},
v47 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isTownsquareHighlight"
},
v48 = [
  (v19/*: any*/),
  (v27/*: any*/),
  (v26/*: any*/),
  (v28/*: any*/),
  (v21/*: any*/)
],
v49 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v48/*: any*/)
},
v50 = {
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": (v48/*: any*/)
},
v51 = {
  "kind": "ScalarField",
  "name": "lastEditedDate"
},
v52 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v53 = {
  "concreteType": "TownsquareHighlightConnection",
  "kind": "LinkedField",
  "name": "highlights",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareHighlightEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v25/*: any*/),
            (v44/*: any*/),
            (v19/*: any*/),
            (v21/*: any*/),
            (v47/*: any*/),
            (v49/*: any*/),
            (v50/*: any*/),
            (v36/*: any*/),
            (v51/*: any*/)
          ]
        }
      ]
    },
    (v52/*: any*/)
  ]
},
v54 = {
  "concreteType": "TownsquareCommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareCommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareComment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v21/*: any*/),
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v19/*: any*/),
                (v26/*: any*/),
                (v21/*: any*/),
                (v28/*: any*/),
                (v27/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v37/*: any*/),
            (v36/*: any*/)
          ]
        }
      ]
    },
    (v52/*: any*/)
  ]
},
v55 = {
  "kind": "ScalarField",
  "name": "canCommentOnUpdates"
},
v56 = {
  "kind": "ScalarField",
  "name": "canEditUpdates"
},
v57 = {
  "kind": "ScalarField",
  "name": "key"
},
v58 = {
  "kind": "ScalarField",
  "name": "isArchived"
},
v59 = [
  (v21/*: any*/),
  (v25/*: any*/),
  {
    "concreteType": "TownsquareUpdateNoteConnection",
    "kind": "LinkedField",
    "name": "updateNotes",
    "plural": false,
    "selections": [
      {
        "concreteType": "TownsquareUpdateNoteEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "TownsquareUpdateNote",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v25/*: any*/),
              (v44/*: any*/),
              (v21/*: any*/)
            ]
          }
        ]
      }
    ]
  }
],
v60 = {
  "kind": "ScalarField",
  "name": "canCreateUpdates"
},
v61 = {
  "kind": "InlineFragment",
  "selections": [
    (v21/*: any*/),
    (v22/*: any*/),
    (v23/*: any*/),
    (v24/*: any*/),
    (v25/*: any*/),
    (v29/*: any*/),
    (v33/*: any*/),
    {
      "concreteType": "TownsquareProjectState",
      "kind": "LinkedField",
      "name": "newState",
      "plural": false,
      "selections": (v34/*: any*/)
    },
    (v35/*: any*/),
    (v36/*: any*/),
    (v37/*: any*/),
    (v38/*: any*/),
    {
      "concreteType": "GraphStoreSimplifiedUserViewedProjectUpdateInverseConnection",
      "kind": "LinkedField",
      "name": "viewers",
      "plural": false,
      "selections": [
        {
          "concreteType": "GraphStoreSimplifiedUserViewedProjectUpdateInverseEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": (v40/*: any*/)
        }
      ]
    },
    {
      "concreteType": "TownsquareProjectState",
      "kind": "LinkedField",
      "name": "oldState",
      "plural": false,
      "selections": (v34/*: any*/)
    },
    (v41/*: any*/),
    (v42/*: any*/),
    (v43/*: any*/),
    (v46/*: any*/),
    (v53/*: any*/),
    (v54/*: any*/),
    {
      "concreteType": "TownsquareProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v21/*: any*/),
        {
          "concreteType": "TownsquareProjectCapabilities",
          "kind": "LinkedField",
          "name": "capabilities",
          "plural": false,
          "selections": [
            (v55/*: any*/),
            (v56/*: any*/)
          ]
        },
        (v57/*: any*/),
        (v58/*: any*/),
        {
          "kind": "ScalarField",
          "name": "startDate"
        },
        {
          "concreteType": "TownsquareProjectUpdate",
          "kind": "LinkedField",
          "name": "latestUserUpdate",
          "plural": false,
          "selections": (v59/*: any*/)
        },
        (v38/*: any*/),
        {
          "concreteType": "TownsquareProjectCapabilities",
          "kind": "LinkedField",
          "name": "capabilities",
          "plural": false,
          "selections": [
            (v60/*: any*/)
          ]
        }
      ]
    }
  ],
  "type": "TownsquareProjectUpdate"
},
v62 = {
  "kind": "ScalarField",
  "name": "value"
},
v63 = {
  "kind": "ScalarField",
  "name": "score"
},
v64 = [
  (v62/*: any*/),
  (v63/*: any*/)
],
v65 = [
  (v62/*: any*/),
  (v21/*: any*/)
],
v66 = {
  "kind": "ScalarField",
  "name": "type"
},
v67 = {
  "kind": "ScalarField",
  "name": "subType"
},
v68 = {
  "kind": "ScalarField",
  "name": "source"
},
v69 = {
  "kind": "ScalarField",
  "name": "time"
},
v70 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": [
    (v69/*: any*/),
    (v21/*: any*/)
  ]
},
v71 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v72 = {
  "kind": "ScalarField",
  "name": "percentage"
},
v73 = [
  (v19/*: any*/),
  (v28/*: any*/),
  (v26/*: any*/),
  (v27/*: any*/),
  (v21/*: any*/)
],
v74 = [
  (v36/*: any*/),
  {
    "concreteType": "TownsquareGoalState",
    "kind": "LinkedField",
    "name": "newState",
    "plural": false,
    "selections": [
      (v62/*: any*/),
      (v63/*: any*/),
      (v30/*: any*/)
    ]
  },
  (v25/*: any*/),
  {
    "kind": "LinkedField",
    "name": "creator",
    "plural": false,
    "selections": (v73/*: any*/)
  },
  (v46/*: any*/),
  {
    "concreteType": "TownsquareHighlightConnection",
    "kind": "LinkedField",
    "name": "highlights",
    "plural": false,
    "selections": [
      {
        "concreteType": "TownsquareHighlightEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v19/*: any*/),
              (v21/*: any*/),
              (v25/*: any*/),
              (v44/*: any*/),
              (v47/*: any*/),
              (v49/*: any*/),
              (v50/*: any*/),
              (v36/*: any*/),
              (v51/*: any*/)
            ]
          }
        ]
      },
      (v52/*: any*/)
    ]
  },
  (v21/*: any*/)
],
v75 = {
  "concreteType": "TownsquareMetricTargetConnection",
  "kind": "LinkedField",
  "name": "metricTargets",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricTargetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricTarget",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v21/*: any*/),
            {
              "concreteType": "TownsquareMetric",
              "kind": "LinkedField",
              "name": "metric",
              "plural": false,
              "selections": [
                (v21/*: any*/),
                (v26/*: any*/),
                (v66/*: any*/),
                (v67/*: any*/),
                (v45/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "externalEntityId"
                },
                (v68/*: any*/),
                (v70/*: any*/)
              ]
            },
            {
              "concreteType": "TownsquareMetricValue",
              "kind": "LinkedField",
              "name": "snapshotValue",
              "plural": false,
              "selections": (v65/*: any*/)
            },
            {
              "kind": "ScalarField",
              "name": "startValue"
            },
            {
              "kind": "ScalarField",
              "name": "targetValue"
            }
          ]
        }
      ]
    }
  ]
},
v76 = {
  "kind": "ScalarField",
  "name": "scoringMode"
},
v77 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "targetDate",
  "plural": false,
  "selections": [
    (v31/*: any*/)
  ]
},
v78 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v73/*: any*/)
},
v79 = [
  (v62/*: any*/)
],
v80 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "messageId"
    },
    {
      "kind": "ScalarField",
      "name": "defaultValue"
    }
  ],
  "type": "TownsquareLocalizationField"
},
v81 = {
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": [
    (v19/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v79/*: any*/),
      "type": "TownsquareGoalTypeCustomName"
    },
    (v80/*: any*/)
  ]
},
v82 = {
  "kind": "LinkedField",
  "name": "namePlural",
  "plural": false,
  "selections": [
    (v19/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v79/*: any*/),
      "type": "TownsquareGoalTypeCustomNamePlural"
    },
    (v80/*: any*/)
  ]
},
v83 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v72/*: any*/),
    (v66/*: any*/)
  ]
},
v84 = {
  "concreteType": "TownsquareGoalUpdate",
  "kind": "LinkedField",
  "name": "latestUserUpdate",
  "plural": false,
  "selections": (v74/*: any*/)
},
v85 = {
  "concreteType": "TownsquareGoalTypeIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v57/*: any*/)
  ]
},
v86 = {
  "concreteType": "TownsquareStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": (v64/*: any*/)
},
v87 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v88 = [
  {
    "concreteType": "TownsquareGoalUpdateEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "TownsquareGoalUpdate",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v37/*: any*/),
          (v36/*: any*/),
          (v21/*: any*/)
        ]
      }
    ]
  }
],
v89 = {
  "kind": "InlineFragment",
  "selections": [
    (v21/*: any*/),
    (v23/*: any*/),
    (v24/*: any*/),
    (v29/*: any*/),
    (v33/*: any*/),
    {
      "concreteType": "TownsquareGoalState",
      "kind": "LinkedField",
      "name": "newState",
      "plural": false,
      "selections": (v64/*: any*/)
    },
    {
      "concreteType": "TownsquareGoalMetricUpdateConnection",
      "kind": "LinkedField",
      "name": "metricUpdate",
      "plural": false,
      "selections": [
        {
          "concreteType": "TownsquareGoalMetricUpdateEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "TownsquareGoalMetricUpdate",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "concreteType": "TownsquareMetricValue",
                  "kind": "LinkedField",
                  "name": "newValue",
                  "plural": false,
                  "selections": (v65/*: any*/)
                },
                {
                  "kind": "ScalarField",
                  "name": "newStartValue"
                },
                {
                  "kind": "ScalarField",
                  "name": "newTargetValue"
                },
                {
                  "concreteType": "TownsquareMetric",
                  "kind": "LinkedField",
                  "name": "metric",
                  "plural": false,
                  "selections": [
                    (v21/*: any*/),
                    (v26/*: any*/),
                    (v66/*: any*/),
                    (v67/*: any*/),
                    (v45/*: any*/),
                    (v68/*: any*/),
                    (v70/*: any*/),
                    {
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "first",
                          "value": 100
                        },
                        {
                          "kind": "Literal",
                          "name": "sort",
                          "value": [
                            "TIME_DESC"
                          ]
                        }
                      ],
                      "concreteType": "TownsquareMetricValueConnection",
                      "kind": "LinkedField",
                      "name": "values",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "TownsquareMetricValueEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "concreteType": "TownsquareMetricValue",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v62/*: any*/),
                                (v69/*: any*/),
                                (v21/*: any*/)
                              ]
                            }
                          ]
                        }
                      ],
                      "storageKey": "values(first:100,sort:[\"TIME_DESC\"])"
                    }
                  ]
                },
                {
                  "concreteType": "TownsquareMetricValue",
                  "kind": "LinkedField",
                  "name": "oldValue",
                  "plural": false,
                  "selections": (v65/*: any*/)
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "args": (v71/*: any*/),
      "concreteType": "TownsquareGoalBundledUpdateConnection",
      "kind": "LinkedField",
      "name": "bundledUpdates",
      "plural": false,
      "selections": [
        {
          "concreteType": "TownsquareGoalBundledUpdateEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "TownsquareGoal",
              "kind": "LinkedField",
              "name": "successMeasure",
              "plural": false,
              "selections": [
                {
                  "concreteType": "TownsquareGoalProgress",
                  "kind": "LinkedField",
                  "name": "progress",
                  "plural": false,
                  "selections": [
                    (v72/*: any*/)
                  ]
                },
                (v21/*: any*/)
              ]
            },
            {
              "concreteType": "TownsquareGoalUpdate",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v74/*: any*/)
            },
            {
              "kind": "ScalarField",
              "name": "nodeMissingReason"
            },
            {
              "concreteType": "TownsquareGoal",
              "kind": "LinkedField",
              "name": "goal",
              "plural": false,
              "selections": [
                (v21/*: any*/),
                (v26/*: any*/),
                {
                  "concreteType": "TownsquareGoalProgress",
                  "kind": "LinkedField",
                  "name": "progress",
                  "plural": false,
                  "selections": [
                    (v66/*: any*/),
                    (v72/*: any*/)
                  ]
                },
                (v75/*: any*/),
                (v38/*: any*/),
                (v76/*: any*/),
                (v77/*: any*/),
                (v78/*: any*/)
              ]
            }
          ]
        }
      ],
      "storageKey": "bundledUpdates(first:50)"
    },
    (v35/*: any*/),
    (v36/*: any*/),
    (v37/*: any*/),
    (v38/*: any*/),
    {
      "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseConnection",
      "kind": "LinkedField",
      "name": "viewers",
      "plural": false,
      "selections": [
        {
          "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": (v40/*: any*/)
        }
      ]
    },
    (v25/*: any*/),
    (v42/*: any*/),
    (v43/*: any*/),
    (v46/*: any*/),
    (v53/*: any*/),
    {
      "concreteType": "TownsquareGoal",
      "kind": "LinkedField",
      "name": "goal",
      "plural": false,
      "selections": [
        (v21/*: any*/),
        (v76/*: any*/),
        (v45/*: any*/),
        {
          "concreteType": "TownsquareGoalType",
          "kind": "LinkedField",
          "name": "goalType",
          "plural": false,
          "selections": [
            {
              "concreteType": "TownsquareGoalType",
              "kind": "LinkedField",
              "name": "successMeasure",
              "plural": false,
              "selections": [
                (v81/*: any*/),
                (v82/*: any*/),
                (v21/*: any*/)
              ]
            },
            (v21/*: any*/)
          ]
        },
        {
          "concreteType": "TownsquareGoalProgress",
          "kind": "LinkedField",
          "name": "progress",
          "plural": false,
          "selections": [
            (v66/*: any*/)
          ]
        },
        {
          "args": (v71/*: any*/),
          "concreteType": "TownsquareGoalConnection",
          "kind": "LinkedField",
          "name": "successMeasures",
          "plural": false,
          "selections": [
            {
              "concreteType": "TownsquareGoalEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "TownsquareGoal",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v21/*: any*/),
                    (v26/*: any*/),
                    (v45/*: any*/),
                    (v83/*: any*/),
                    (v75/*: any*/),
                    (v38/*: any*/),
                    (v76/*: any*/),
                    (v77/*: any*/),
                    (v78/*: any*/),
                    (v84/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "uuid"
                    },
                    (v58/*: any*/),
                    {
                      "concreteType": "TownsquareGoalType",
                      "kind": "LinkedField",
                      "name": "goalType",
                      "plural": false,
                      "selections": [
                        (v81/*: any*/),
                        (v82/*: any*/),
                        (v85/*: any*/),
                        (v21/*: any*/)
                      ]
                    },
                    (v86/*: any*/),
                    {
                      "args": (v87/*: any*/),
                      "concreteType": "TownsquareGoalUpdateConnection",
                      "kind": "LinkedField",
                      "name": "updates",
                      "plural": false,
                      "selections": (v88/*: any*/),
                      "storageKey": "updates(first:10)"
                    }
                  ]
                },
                (v19/*: any*/)
              ]
            }
          ],
          "storageKey": "successMeasures(first:50)"
        },
        {
          "concreteType": "TownsquareGoalConnection",
          "kind": "LinkedField",
          "name": "subGoals",
          "plural": false,
          "selections": [
            {
              "concreteType": "TownsquareGoalEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "TownsquareGoal",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v21/*: any*/),
                    (v26/*: any*/),
                    (v45/*: any*/),
                    (v83/*: any*/),
                    {
                      "concreteType": "TownsquareGoalType",
                      "kind": "LinkedField",
                      "name": "goalType",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "kind"
                        },
                        (v21/*: any*/),
                        (v85/*: any*/)
                      ]
                    },
                    (v75/*: any*/),
                    (v38/*: any*/),
                    (v76/*: any*/),
                    (v77/*: any*/),
                    (v78/*: any*/),
                    (v84/*: any*/),
                    (v58/*: any*/),
                    (v86/*: any*/),
                    {
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "first",
                          "value": 30
                        }
                      ],
                      "concreteType": "TownsquareGoalUpdateConnection",
                      "kind": "LinkedField",
                      "name": "updates",
                      "plural": false,
                      "selections": (v88/*: any*/),
                      "storageKey": "updates(first:30)"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "args": (v87/*: any*/),
          "concreteType": "TownsquareGoalUpdateConnection",
          "kind": "LinkedField",
          "name": "updates",
          "plural": false,
          "selections": [
            {
              "concreteType": "TownsquareGoalUpdateEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "TownsquareGoalUpdate",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v59/*: any*/)
                }
              ]
            }
          ],
          "storageKey": "updates(first:10)"
        },
        {
          "concreteType": "TownsquareMetricTargetConnection",
          "kind": "LinkedField",
          "name": "metricTargets",
          "plural": false,
          "selections": [
            {
              "concreteType": "TownsquareMetricTargetEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "TownsquareMetricTarget",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "TownsquareMetric",
                      "kind": "LinkedField",
                      "name": "metric",
                      "plural": false,
                      "selections": [
                        (v21/*: any*/),
                        (v45/*: any*/)
                      ]
                    },
                    (v21/*: any*/)
                  ]
                }
              ]
            }
          ]
        },
        (v57/*: any*/),
        {
          "kind": "ScalarField",
          "name": "canPostUpdate"
        },
        (v58/*: any*/),
        {
          "concreteType": "TownsquareGoalCapabilities",
          "kind": "LinkedField",
          "name": "capabilities",
          "plural": false,
          "selections": [
            (v60/*: any*/),
            (v56/*: any*/),
            {
              "kind": "ScalarField",
              "name": "canDeleteUpdates"
            },
            (v55/*: any*/)
          ]
        },
        {
          "kind": "ScalarField",
          "name": "canEditUpdate"
        }
      ]
    },
    (v22/*: any*/),
    (v54/*: any*/),
    {
      "concreteType": "TownsquareGoalState",
      "kind": "LinkedField",
      "name": "oldState",
      "plural": false,
      "selections": (v64/*: any*/)
    },
    (v41/*: any*/)
  ],
  "type": "TownsquareGoalUpdate"
},
v90 = [
  (v21/*: any*/),
  (v26/*: any*/)
],
v91 = {
  "kind": "InlineFragment",
  "selections": [
    (v21/*: any*/),
    {
      "concreteType": "TownsquareProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": (v90/*: any*/)
    },
    {
      "alias": "newProjectState",
      "concreteType": "TownsquareProjectState",
      "kind": "LinkedField",
      "name": "newState",
      "plural": false,
      "selections": (v79/*: any*/)
    },
    (v23/*: any*/),
    (v24/*: any*/)
  ],
  "type": "TownsquareProjectUpdate"
},
v92 = {
  "kind": "InlineFragment",
  "selections": (v39/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v93 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v94 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v95 = [
  "createdBefore",
  "createdAfter",
  "containerId",
  "stateFilter"
],
v96 = {
  "kind": "InlineFragment",
  "selections": [
    (v21/*: any*/),
    {
      "concreteType": "TownsquareGoal",
      "kind": "LinkedField",
      "name": "goal",
      "plural": false,
      "selections": (v90/*: any*/)
    },
    {
      "alias": "newGoalState",
      "concreteType": "TownsquareGoalState",
      "kind": "LinkedField",
      "name": "newState",
      "plural": false,
      "selections": (v79/*: any*/)
    },
    (v23/*: any*/),
    (v24/*: any*/)
  ],
  "type": "TownsquareGoalUpdate"
},
v97 = [
  {
    "concreteType": "TownsquareUpdateEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      (v19/*: any*/),
      {
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v20/*: any*/),
          (v19/*: any*/),
          (v61/*: any*/),
          (v89/*: any*/),
          (v91/*: any*/),
          (v96/*: any*/),
          (v92/*: any*/)
        ]
      },
      (v93/*: any*/)
    ]
  },
  (v94/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ReadingModeFullScreenQuery",
    "selections": [
      {
        "condition": "isProjectUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v15/*: any*/),
            "kind": "FragmentSpread",
            "name": "ProjectReadingModeInternals_ProjectPagination"
          }
        ]
      },
      {
        "condition": "isGoalUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v15/*: any*/),
            "kind": "FragmentSpread",
            "name": "GoalReadingModeInternals_GoalPagination"
          }
        ]
      },
      {
        "condition": "isTeamUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v16/*: any*/),
            "kind": "FragmentSpread",
            "name": "TeamReadingModeInternals_TeamPagination"
          }
        ]
      },
      {
        "condition": "isTagUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v17/*: any*/),
            "kind": "FragmentSpread",
            "name": "TagReadingModeInternals_TagPagination"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v3/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v7/*: any*/),
      (v9/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Operation",
    "name": "ReadingModeFullScreenQuery",
    "selections": [
      {
        "condition": "isProjectUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v18/*: any*/),
            "kind": "ScalarField",
            "name": "projects_allWatchedProjectUpdatesCount"
          },
          {
            "args": (v15/*: any*/),
            "concreteType": "TownsquareUpdateConnection",
            "kind": "LinkedField",
            "name": "projects_allWatchedProjectUpdates",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v61/*: any*/),
                      (v89/*: any*/),
                      (v91/*: any*/),
                      (v92/*: any*/)
                    ]
                  },
                  (v93/*: any*/)
                ]
              },
              (v94/*: any*/)
            ]
          },
          {
            "args": (v15/*: any*/),
            "filters": (v95/*: any*/),
            "handle": "connection",
            "key": "ProjectReadingModeInternals__projects_allWatchedProjectUpdates",
            "kind": "LinkedHandle",
            "name": "projects_allWatchedProjectUpdates"
          }
        ]
      },
      {
        "condition": "isGoalUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v18/*: any*/),
            "kind": "ScalarField",
            "name": "goals_allWatchedGoalUpdatesCount"
          },
          {
            "args": (v15/*: any*/),
            "concreteType": "TownsquareUpdateConnection",
            "kind": "LinkedField",
            "name": "goals_allWatchedGoalUpdates",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v61/*: any*/),
                      (v89/*: any*/),
                      (v96/*: any*/),
                      (v92/*: any*/)
                    ]
                  },
                  (v93/*: any*/)
                ]
              },
              (v94/*: any*/)
            ]
          },
          {
            "args": (v15/*: any*/),
            "filters": (v95/*: any*/),
            "handle": "connection",
            "key": "GoalReadingModeInternals__goals_allWatchedGoalUpdates",
            "kind": "LinkedHandle",
            "name": "goals_allWatchedGoalUpdates"
          }
        ]
      },
      {
        "condition": "isTeamUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v16/*: any*/),
            "concreteType": "TownsquareUpdateConnection",
            "kind": "LinkedField",
            "name": "statusUpdates_byTeam",
            "plural": false,
            "selections": (v97/*: any*/)
          },
          {
            "args": (v16/*: any*/),
            "filters": [
              "teamId",
              "containerId",
              "createdAfter"
            ],
            "handle": "connection",
            "key": "TeamReadingModeInternals__statusUpdates_byTeam",
            "kind": "LinkedHandle",
            "name": "statusUpdates_byTeam"
          }
        ]
      },
      {
        "condition": "isTagUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v17/*: any*/),
            "concreteType": "TownsquareUpdateConnection",
            "kind": "LinkedField",
            "name": "statusUpdates_byTag",
            "plural": false,
            "selections": (v97/*: any*/)
          },
          {
            "args": (v17/*: any*/),
            "filters": [
              "tagId",
              "createdAfter",
              "containerId"
            ],
            "handle": "connection",
            "key": "TagReadingModeInternals__statusUpdates_byTag",
            "kind": "LinkedHandle",
            "name": "statusUpdates_byTag"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "5408a98b5c717cefdf26326d1df7b97015009d11ef1e09a7900ed8888261a004",
    "metadata": {},
    "name": "ReadingModeFullScreenQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "b990a1438fe3e2224d1c2f93dd71fffe";

export default node;
